var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXiugaixianxing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_1792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.29987 1.51094L11.2909 3.50198L2.56716 12.2257L0.494885 12.307L0.576114 10.2347L9.29987 1.51094Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1875 6.03125L11.0156 6.03125",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1875 8.90625L8.89062 8.90625",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1875 12.5625L5.71875 12.5625",
    stroke: "black",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_1792"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXiugaixianxing);
export default __webpack_public_path__ + "static/media/xiugaixianxing.5744fc5ce1bb8293873f4d392a74b9da.svg";
export { ForwardRef as ReactComponent };